//v1 paths
export const FOUNDATION_PATH = 'main/foundation-profile';
export const FOUNDATION_CA_PATH = 'main/foundation-profile-ca';
export const CUSTOM_PROFILE_PATH = 'main/custom-profile';
export const DOCUMENT_GENERATOR_PATH = 'main/document-generator';

//search engines
export const GIVING_HISTORY_PATH = 'main/search/by-giving-history';
export const GIVING_HISTORY_CA_PATH = 'main/search/giving-history-ca';
export const KEYWORD_PATH = 'main/search/by-keyword';
export const NAME_PATH = 'main/search/by-name';
export const NAME_CA_PATH = 'main/search/name-ca';
export const DIRECTOR_PATH = 'main/search/by-director';
export const DIRECTOR_CA_PATH = 'main/search/directors-ca';
export const YEAR_PATH = 'main/search/by-year';
export const YEAR_CA_PATH = 'main/search/year-ca';
export const CUSTOM_PATH = 'main/search/by-custom';
export const NEW_CUSTOM_PROFILE_PATH = 'main/search/by-custom-profile';
export const INTERNATIONAL_FUNDING_PATH = 'main/search/by-international-funding';

//v2 paths
export const FOUNDATION_V2_PATH = 'main/foundation-profile-v2';
export const FOUNDATION_CA_V2_PATH = 'main/foundation-profile-ca-v2';
export const FAVORITES_PATH = '/main/manage-funders';
export const CUSTOM_PROFILE_V2_PATH = 'main/custom-profile-v2';
export const DOCUMENT_GENERATOR_V2_PATH = 'main/new-document-generator';

//v3 paths
export const CUSTOM_PROFILE_V3_PATH = 'main/custom-profile-v3';
export const SEARCH_ENGINE_V3_PATH = 'main/search/new';

//search engines
export const GIVING_HISTORY_V2_PATH = 'main/search/giving-history-v2';
export const GIVING_HISTORY_CA_V2_PATH = 'main/search/giving-history-ca-v2';
export const KEYWORD_V2_PATH = 'main/search/by-keyword-v2';
export const NAME_V2_PATH = 'main/search/by-name-v2';
export const NAME_CA_V2_PATH = 'main/search/name-ca-v2';
export const DIRECTOR_V2_PATH = 'main/search/by-director-v2';
export const DIRECTOR_CA_V2_PATH = 'main/search/directors-ca-v2';
export const YEAR_V2_PATH = 'main/search/by-year-v2';
export const YEAR_CA_V2_PATH = 'main/search/year-ca-v2';
export const CUSTOM_V2_PATH = 'main/search/by-custom-v2';
export const INTERNATIONAL_FUNDING_V2_PATH = 'main/search/by-international-funding-v2';

export const GRANT_SECRETARY_PATH = 'main/legacy-grant-secretary';
export const GRANT_SECRETARY_V2_PATH = 'main/grant-secretary';
export const DASHBOARD_PATH = 'main/dashboard/default';


// reCAPTCHA configuration
export const RECAPTCHA_SITE_KEY = '6Lfpl2EsAAAAAC8Y2LQWDWS_9qxFkFTxJBr2W3nn';

// Help Center Url
export const HELP_CENTER_URL = 'https://grantadvance.supportbee.io/2439-the-simple-funding-solution'
